<template>
  <section>
    <nav-bar
      v-if="sites.length > 0"
      :blocked-modules="blockedModules"
      :site-id="siteId"
      :sites="sites"
      :study-id="studyId"
      :user="user"
      @updateGetStudySites="updateGetStudySites"
    ></nav-bar>

    <router-view
      :blocked-modules="blockedModules"
      :studySite="studySite"
      :user="user"
    ></router-view>
  </section>
</template>
<script>
  import NavBar from './utility/NavBar';

  export default {
    name: 'StudySiteDetails',
    components: {
      NavBar,
    },
    props: {
      sites: Array,
      user: Object,
    },
    data() {
      return {
        siteId: '',
        studyId: '',
        studySite: {},
        modulesMap: {
          // 'Enrollment Oversight': {
          //   route: 'site-enrollment',
          //   permission: 'access enrollment oversight',
          // },
          Enrollment: {
            route: 'site-enrollment',
            detailsRoute: '',
            permission: 'access my enrollments',
          },
          'Start-Up Plan': {
            route: 'start-up-plan',
            detailsRoute: '',
            permission: 'access start-up plan',
          },
          Milestones: {
            route: 'study-site-milestones',
            detailsRoute: '',
            permission: 'access milestones',
          },
          'System Outage': {
            route: 'system-outage-messages',
            detailsRoute: '',
            permission: 'access system outage messages',
          },
          'Application Access': {
            route: 'application-access',
            detailsRoute: 'ticket-details',
            permission: 'access application access',
          },
          Forms: {
            route: 'forms',
            detailsRoute: 'form-create',
            permission: 'access forms',
          },
        },
        blockedModules: [],
      };
    },
    computed: {
      isEnrollmentOversight() {
        return this.$route.name.includes('oversight');
      },
    },
    watch: {
      $route() {
        this.studyId = this.$route.params['studyId'];
        this.siteId = this.$route.params['siteId'];
      },
      studyId() {
        this.getBlockedModules();
      },
    },
    created() {
      this.blockedModules = Object.keys(this.modulesMap);
      this.studyId = this.$route.params['studyId'];
      this.siteId = this.$route.params['siteId'];
    },
    methods: {
      updateGetStudySites(payload) {
        this.studySite = payload.find(element => {
          return (
            element['siteInfo']['siteNumber'] === this.$route.params['siteId'] &&
            element['studyInfo']['studyID'] === this.$route.params['studyId']
          );
        });
      },
      async getBlockedModules() {
        this.blockedModules = [
          'Enrollment',
          'Enrollment Oversight',
          'Application Access',
          'Start-Up Plan',
          'Milestones',
          'System Outage',
          'Forms',
        ];
        await axios
          .get(`/api/get-blocked-modules?study=` + this.studyId)
          .then(response => {
            let userRequestedRoute = this.$route.name;

            this.blockedModules = response.data.items;
            const getRequestedModule = function(obj, value) {
              return Object.keys(obj).find(key => obj[key]['route'] === value);
            };

            const getRequestedModuleDetails = function(obj, value) {
              return Object.keys(obj).find(key => obj[key]['detailsRoute'] === value);
            };

            let userRequestedModule = getRequestedModule(this.modulesMap, userRequestedRoute);

            if (!userRequestedModule) {
              userRequestedModule = getRequestedModuleDetails(this.modulesMap, userRequestedRoute);
            }

            let canAccessRequestedPage = this.blockedModules.includes(userRequestedModule);

            if (canAccessRequestedPage) {
              return this.userNotAllowed(userRequestedModule);
            }

            // let newMap = _.cloneDeep(this.modulesMap);
            //
            // const allBlocked = Object.keys(newMap).every(r => this.blockedModules.indexOf(r) >= 0);
            // if (allBlocked) {
            //   this.$router.replace({ name: 'not-found' });
            //   return;
            // }
            //
            // if (this.isEnrollmentOversight) {
            //   Object.keys(newMap).forEach(key => {
            //     newMap[key]['route'] = 'oversight-' + newMap[key]['route'];
            //   });
            // }
            // let allModules = Object.keys(newMap);
            // let allowedModules = allModules.filter(
            //   element => !this.blockedModules.includes(element),
            // );
            // let firstAllowedModule = allowedModules[0];
            // let userRequestedRoute = this.$route.name;
            //
            // // module filtering
            // let allowedModulesMap = Object.keys(newMap)
            //   .filter(key => allowedModules.includes(key))
            //   .reduce((obj, key) => {
            //     obj[key] = newMap[key];
            //     return obj;
            //   }, {});
            //
            // //permission filtering
            // let permissions = this.user.permissions.map(permission => permission.name);
            // allowedModulesMap = Object.keys(allowedModulesMap)
            //   .filter((key, index) => permissions.includes(allowedModulesMap[key]['permission']))
            //   .reduce((obj, key) => {
            //     obj[key] = allowedModulesMap[key];
            //     return obj;
            //   }, {});
            //
            // const getRequestedModule = function(obj, value) {
            //   return Object.keys(obj).find(key => obj[key]['route'] === value);
            // };
            //
            // const getRequestedModuleDetails = function(obj, value) {
            //   return Object.keys(obj).find(key => obj[key]['detailsRoute'] === value);
            // };
            //
            // let userRequestedModule = getRequestedModule(newMap, userRequestedRoute);
            //
            // if (!userRequestedModule) {
            //   userRequestedModule = getRequestedModuleDetails(newMap, userRequestedRoute);
            // }
            //
            // if (Object.keys(allowedModulesMap).length === 0) {
            //   return this.userNotAllowed(userRequestedModule);
            // }
            //
            // firstAllowedModule = Object.keys(allowedModulesMap)[0];
            // let firstAllowedRoute = allowedModulesMap[firstAllowedModule]['route'];
            // if (userRequestedRoute === 'site-details') {
            //   return this.$router.replace({
            //     name: 'site-summary',
            //     params: {
            //       siteId: this.$route.params.siteId,
            //       studyId: this.$route.params.studyId,
            //     },
            //   });
            // }
            //
            // if (userRequestedRoute === 'site-summary') {
            //   return;
            // }
            //
            // let canAccessRequestedPage = () => {
            //   let obj = Object.values(allowedModulesMap);
            //   const check = obj =>
            //     obj.route.includes(userRequestedRoute) ||
            //     obj.detailsRoute.includes(userRequestedRoute);
            //   return obj.some(check);
            // };
            //
            // if (!userRequestedModule) {
            //   this.$router.replace({
            //     name: firstAllowedRoute,
            //     params: {
            //       siteId: this.$route.params.siteId,
            //       studyId: this.$route.params.studyId,
            //       eventId: this.$route.params.eventId,
            //     },
            //   });
            // } else if (!canAccessRequestedPage()) {
            //   return this.userNotAllowed(userRequestedModule);
            // }
          })
          .catch(e => console.error(e));
      },
      userNotAllowed(userRequestedModule) {
        return this.$router
          .replace({
            name: 'site-summary',
            params: {
              siteId: this.$route.params.siteId,
              studyId: this.$route.params.studyId,
            },
          })
          .then(r => {
            this.$bvToast.toast(`Access denied for ${userRequestedModule}`, {
              title: 'Error',
              autoHideDelay: 5000,
              appendToast: true,
              variant: 'danger',
            });
          });
      },
    },
  };
</script>
